export default __webpack_public_path__ + "static/app_screenshot_5-1ed9cf93df3f7f6efe13f3e3ffd02074.webp";